import { render, staticRenderFns } from "./MainLedgerDelete.vue?vue&type=template&id=66e7259a&scoped=true"
import script from "./MainLedgerDelete.vue?vue&type=script&lang=js"
export * from "./MainLedgerDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e7259a",
  null
  
)

export default component.exports